import { render, staticRenderFns } from "./CriticismTableContentComponent.vue?vue&type=template&id=cbf7aaec&scoped=true&"
import script from "./CriticismTableContentComponent.vue?vue&type=script&lang=js&"
export * from "./CriticismTableContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./CriticismTableContentComponent.vue?vue&type=style&index=0&id=cbf7aaec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf7aaec",
  null
  
)

export default component.exports